const translations = {
  title: 'Nuevo Usuario',
  title_edit: 'Editando Usuario',
  bulkEdit: 'Registro en masa',
  name: 'Nombre',
  email: 'Email',
  profile: 'Perfil',
  groups: 'Grupos',
  productiveCapacity: 'Capacidad productiva',
  relatedUsers: 'Usuarios relacionados',
  fakeEmailQuestion: '¿Correo electrónico ficticio?',
  fakeEmail: 'Correo electrónico ficticio',
  canAccessPaymentModule: 'Puede acceder al módulo de pago',
  changingPassword: 'Cambiando contraseña de {{name}}',
  temporaryPassword: 'Contraseña temporal',
  temporaryPasswordConfirmation: 'Confirmación de contraseña temporal',
  passwordRequired: 'Contraseña obligatoria',
  minCharacters: 'Mínimo de {{count}} caracteres',
  passwordsDoNotMatch: 'Las contraseñas no coinciden',
  maxLengthExceeded: 'Tamaño máximo excedido',
  checkWorkShifts: 'Verifique los turnos de trabajo',
  successTitle: '¡Registrado con éxito!',
  successMessage: 'Usuario registrado con éxito.'
}

export default translations
